import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition } from "vue"

import {computed, watch, ref, onMounted} from 'vue'
  import {useStore} from 'vuex'

  import NotificationContainer from '@/components/NotificationContainer'

  import {t} from '@/lib/i18n'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'BufferingNotification',
  props: {
    active: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    active: boolean
  };

  const store = useStore()

  const bufferingText = computed(() => t(store, 'buffering'))

  

  const visible = ref(false)

  let timeout = null

  onMounted(() => {
    timeout = window.setTimeout(() => {
      visible.value = true
    }, 1000)
  })

  watch(props.active, (value) => {
    if (value) {
      timeout = window.setTimeout(() => {
        visible.value = true
      }, 1000)
    } else {
      if (timeout) {
        window.clearTimeout(timeout)
      }
    }
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (props.active && visible.value)
        ? (_openBlock(), _createBlock(_unref(NotificationContainer), {
            key: 0,
            class: "buffering-notification"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(bufferingText)), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})